import { updateCompany } from '../components/API';
import { GetStartedData } from '../Types';

export const GET_STARTED_DATA_KEY = 'get_started_data';

export async function updateCompanyWithGetStartedData(
  getStartedData: GetStartedData,
) {
  const { leadId, passedMinRevenue, platform } = getStartedData;
  await updateCompany({
    lead_id: leadId,
    passedMinRevenue,
    seller_store: platform,
  });
}
